module.exports = __webpack_public_path__ + "img/pointer.d85be1c4.png";